<template>
  <div class="responsive-actions" :class="{ fixed, shadows }">
    <c-button
      size="large"
      class="responsive-actions__reset"
      :class="{ 'sm-border-color': !shadows }"
      :label="resetLabel"
      @click="$emit('on-reset')"
    />
    <c-button
      v-show="!hideResetButton"
      class="responsive-actions__save"
      :label="submitLabel"
      color="primary"
      size="large"
      :disabled-but-clickable="disabledButClickableSubmit"
      :disabled="disableSubmit"
      @click="$emit('on-submit')"
    />
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";

export default {
  name: "responsive-apply-reset-actions",
  components: {
    "c-button": Button,
  },
  props: {
    resetLabel: {
      type: String,
      default: () => "Отменить",
    },
    submitLabel: {
      type: String,
      default: () => "Сохранить",
    },
    disableSubmit: {
      type: Boolean,
      default: () => false,
    },
    disabledButClickableSubmit: {
      type: Boolean,
      default: () => false,
    },
    fixed: {
      type: Boolean,
      default: () => true,
    },
    shadows: {
      type: Boolean,
      default: () => true,
    },
    hideResetButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.responsive-actions {
  display: flex;
  margin-top: 40px;

  &__reset {
    background-color: #fff;
    margin-right: 10px;

    @include onlyExtraSmall {
      border-left: none;
      border-bottom: none;
      border-color: #fff;
    }
  }

  &__save[disabled="disabled"] {
    opacity: 1;
    background-color: #9bc3ff;
    border-color: #9bc3ff;
  }

  @include onlyExtraSmall {
    bottom: 0;
    width: 100vw;
    margin-left: -20px;

    & > button {
      width: 50%;
      border-radius: 0;
      margin: 0;
    }
  }
}
.fixed {
  @include onlyExtraSmall {
    position: fixed;
  }
}
.shadows {
  @include onlyExtraSmall {
    box-shadow: 0 -4px 4px #00000025;
  }
}
.sm-border-color {
  @include onlyExtraSmall {
    border-color: $color-border;
  }
}
</style>
